<template>
  <div class="container">
    <div class="shop_top">
      <custom-head :title="lang.shop_cart" :nav_show="true" />
    </div>
    <div v-loading="loading" class="width_center_1200">
      <div class="goods_info_top_mbx width_center_1200">
        <el-breadcrumb separator=">">
          <el-breadcrumb-item :to="{ path: '/' }">{{ lang.home }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ lang.shop_cart }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <template v-if="carts.length">
        <ul class="cart-head">
          <li class="goods-info">
            <span>{{ lang.title_row1 }}</span>
          </li>
          <li class="goods-price">
            <span>{{ lang.title_row2 }}</span>
          </li>
          <li class="goods-num">
            <span>{{ lang.title_row3 }}</span>
          </li>
          <li class="goods-amount">
            <span>{{ lang.title_row4 }}</span>
          </li>
          <li class="action">
            <span>{{ lang.title_row5 }}</span>
          </li>
        </ul>
        <div class="cart-content">
          <cart-card v-for="(item, index) in carts" :key="index" :info="item"></cart-card>
        </div>
      </template>
      <div v-if="noList" class="empty_order">
        <dl>
          <dt>
            <img src="/images/not-common-icon.png" />
          </dt>
          <dd>{{ lang.empty_tips }}</dd>
          <dd class="btn">
            <router-link to="/">{{ lang.go_to_mall }}</router-link>
          </dd>
        </dl>
      </div>
    </div>
    <shop-foot></shop-foot>
    <!-- vue 回到顶部 -->
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CustomHead from '@/components/CustomHead/index'
import ShopFoot from '@/components/ShopFoot/index.vue'
import { getcartTreelist } from '@/api/cart.js'
import CartCard from './components/cart-card'
export default {
  components: {
    CustomHead,
    ShopFoot,
    CartCard
  },
  data() {
    return {
      carts: [],
      loading: false,
      noList: false
    }
  },
  computed: {
    lang() {
      return this.$t('cart')
    },
    ...mapGetters(['isLogin', 'location', 'unit'])
  },
  async created() {
    this.init()
  },
  methods: {
    init() {
      this.loading = true
      getcartTreelist().then(({ data }) => {
        if (data.length === 0) {
          this.noList = true
        }
        this.loading = false
        data.forEach((item) => {
          item.checked = false
        })
        this.carts = data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
}
.empty_order {
  padding: 100px 0 200px;
}
.goods_info_top_mbx {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  /deep/ .el-breadcrumb__inner {
    font-size: 14px;
    color: #aaa !important;
    font-weight: 400 !important;
  }
  /deep/ .el-breadcrumb__separator {
    font-weight: 400;
  }
  .el-breadcrumb {
    line-height: 44px;
  }
  .action-box {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    li {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #aaa;
      margin-left: 20px;
      .svg-icon {
        margin-right: 4px;
        width: 18px;
        height: 18px;
      }
      &:hover {
        cursor: pointer;
        color: #ec9221;
      }
    }
  }
}


.cart-head {
  height: 38px;
  line-height: 38px;
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  li {
    font-size: 14px;
    color: #000;
    span {
      padding-left: 28px;
    }
    &.goods-info {
      width: 570px;
      span {
        padding-left: 160px;
      }
    }
    &.goods-price,
    &.goods-num {
      width: 165px;
    }
    &.goods-amount {
      width: 172px;
    }
  }
}

.cart-content {
  margin-bottom: 60px;
}
</style>